"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var cz_1 = __importDefault(require("faker/locale/cz"));
exports.fakerCZ = cz_1.default;
var en_1 = __importDefault(require("faker/locale/en"));
exports.fakerEN = en_1.default;
var sk_1 = __importDefault(require("faker/locale/sk"));
exports.fakerSK = sk_1.default;
//# sourceMappingURL=faker.js.map